import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { IMAGES } from "../../lib/data";

export const ProductCard = ({ product, index = 0 }) => {
    const { addToCart } = useCart();
    const image = product.kind === "popcorn" ? IMAGES.popcorn : IMAGES.cottonCandy;
    const soldOut = product.status === "SOLD_OUT";
    const comingSoon = product.status === "COMING_SOON";
    const unavailable = soldOut || comingSoon;

    return (
        <motion.article
            data-testid={`product-card-${product.id}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className="group bg-white border border-zinc-200 rounded-3xl overflow-hidden"
        >
            <div className="relative aspect-[4/5] overflow-hidden bg-paper">
                <img
                    src={product.image || image}
                    alt={product.name}
                    loading="lazy"
                    className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${unavailable ? "grayscale opacity-70" : ""}`}
                />
                {soldOut ? (
                    <span className="absolute top-4 left-4 bg-pink text-ink font-oswald text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full">
                        Sold Out
                    </span>
                ) : comingSoon ? (
                    <span className="absolute top-4 left-4 bg-white text-ink border-2 border-pink font-oswald text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full">
                        Coming Soon
                    </span>
                ) : product.tag ? (
                    <span className="absolute top-4 left-4 bg-ink text-white font-oswald text-[10px] tracking-[0.25em] uppercase px-3 py-1.5 rounded-full">
                        {product.tag}
                    </span>
                ) : null}
            </div>
            <div className="p-5 flex items-end justify-between gap-3">
                <div>
                    <p className="text-[10px] font-bold tracking-[0.3em] uppercase text-pink-dark mb-1">{product.category}</p>
                    <h3 className="font-oswald uppercase text-lg leading-tight text-ink">{product.name}</h3>
                    {!comingSoon && (
                        <p className="mt-1 font-manrope font-bold text-sm text-zinc-500">
                            ${Number(product.price).toFixed(2)}
                        </p>
                    )}
                </div>
                {!comingSoon && (
                    <button
                        onClick={() => !soldOut && addToCart(product)}
                        disabled={soldOut}
                        data-testid={`add-to-cart-${product.id}`}
                        aria-label={soldOut ? `${product.name} sold out` : `Add ${product.name} to cart`}
                        className={`shrink-0 h-11 w-11 rounded-full flex items-center justify-center transition-colors duration-300 ${
                            soldOut
                                ? "bg-zinc-200 text-zinc-400 cursor-not-allowed"
                                : "bg-ink text-white hover:bg-pink hover:text-ink active:scale-90"
                        }`}
                    >
                        <Plus size={18} />
                    </button>
                )}
            </div>
        </motion.article>
    );
};
